export const FIELD_OPTIONS = {
  SORTED: 'field-options-sorted',
  ADDED_AVAILABLE_OPTIONS: 'options-added-available-options',
  REORDERED_ROW: 'options-reordered-row',
  REMOVED_ROW: 'options-removed-row',
  UPDATED_PRESELECTED: 'options-updated-preselected',
  UPDATED_LABEL: 'options-updated-label',
  CLEARED_PRESELECTED: 'options-cleared-preselected'
};
export const DASHBOARD_BANNER = {
  NOTIFICATION_RECIPIENT_BANNER_SHOWN: 'notification-recipient-banner-shown',
  NOTIFICATION_RECIPIENT_BANNER_ALERT_DISMISSED: 'notification-recipient-banner-alert-dismissed',
  NOTIFICATION_RECIPIENT_BANNER_CSV_DOWNLOAD: 'notification-recipient-banner-csv-download'
};